module.exports = __webpack_public_path__ + "static/media/gGrothman.2149f1a2.jpeg";